import { Directive, TemplateRef } from '@angular/core';

/**
 * Only used to inject templates and know what it is intended to replace
 */
@Directive({ selector: '[ui-list-cell-template]' })
export class UIListCellTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
